import type { ArchiveOrgUserMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { ArchiveOrgUserDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

/**
 * Archive a non-SCIM org user. Server-side guards (self-archive, SCIM, status
 * precondition) are enforced on both paths; this hook is a thin
 * presentation-side wrapper. `refetchQueries: ['GetAuthUsers']` is by
 * operation name so it matches the active observable regardless of variables.
 */
export const useArchiveUser = createMutationHook({
  name: 'archiveUser',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.user.archiveUser.mutationOptions({ onSuccess }),
  mapInput: (userId: string) => ({ userId }),
  invalidate: (trpc) => [trpc.frontend.user.users.queryKey()],
  mapResponse: (result: {
    Id: string;
    Status: string;
  }): ArchiveOrgUserMutation => ({
    archive_org_user: {
      __typename: 'OrgUserStatusTransitionOutput',
      Id: result.Id,
      Status: result.Status,
    },
  }),
  graphqlDocument: ArchiveOrgUserDocument,
  graphqlVariables: (userId: string) => ({ userId }),
  evictFields: ['auth_user', 'auth_user_aggregate'],
  refetchQueries: ['GetAuthUsers'],
  awaitRefetchQueries: true,
});
